import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { IconButton, Tooltip } from '@mui/material';
import { Block, CheckCircle, Delete, Edit } from '@mui/icons-material';
import {
  ApiKeyResponseDto,
  ApiKeyStatus,
} from '../../../common/model/dto/api-key';

interface OvApiKeyRowActionsProps {
  apiKey: ApiKeyResponseDto;
  onDelete: (id: string) => void;
  onRevoke: (id: string) => void;
  onActivate: (id: string) => void;
}

const OvApiKeyRowActions: FC<OvApiKeyRowActionsProps> = ({
  apiKey,
  onDelete,
  onRevoke,
  onActivate,
}) => {
  const { t } = useTranslation();
  const apiKeyId = apiKey.id as string;

  return (
    <>
      <Tooltip title={t('common.actions.edit')}>
        <IconButton
          size="small"
          component={NavLink}
          to={`/api-keys/edit/${apiKeyId}`}
          aria-label={t('common.actions.edit')}
        >
          <Edit />
        </IconButton>
      </Tooltip>
      {apiKey.status === ApiKeyStatus.ACTIVE ? (
        <Tooltip title={t('apiKeys.actions.revoke')}>
          <IconButton
            size="small"
            aria-label={t('apiKeys.actions.revoke')}
            onClick={() => onRevoke(apiKeyId)}
          >
            <Block />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title={t('apiKeys.actions.activate')}>
          <IconButton
            size="small"
            aria-label={t('apiKeys.actions.activate')}
            onClick={() => onActivate(apiKeyId)}
          >
            <CheckCircle />
          </IconButton>
        </Tooltip>
      )}
      <Tooltip title={t('common.actions.delete')}>
        <IconButton
          size="small"
          aria-label={t('common.actions.delete')}
          onClick={() => onDelete(apiKeyId)}
        >
          <Delete />
        </IconButton>
      </Tooltip>
    </>
  );
};

export default OvApiKeyRowActions;
